import TransactionHistory from "../components/TransactionHistory/TransactionHistory";

const TransactionHistoryPage = () => {
  return <TransactionHistory />;
};

export default TransactionHistoryPage;
